export default "__VITE_ASSET__B4ZdkD55__"